import React from 'react'
import classNames from 'classnames'

import Collapse, { Panel } from 'rc-collapse'

const Title = ({ plain, titleIcon, title }) => (
  <div className={`${plain ? 'plain-' : ''}collapse__title`}>
    <div
      className={`${
        plain ? 'text-secondary' : 'pr-6'
      } text-base font-bold leading-normal relative collapse__title-heading`}
    >
      <div className={`${titleIcon ? 'flex items-center justify-center' : ''}`}>
        {titleIcon && (
          <div className="pr-1 inline-flex" role="presentation">
            {titleIcon}
          </div>
        )}
        {title}
      </div>
      <div
        className={`${plain ? 'plain-' : ''}collapse__arrow`}
        role="presentation"
      />
    </div>
  </div>
)

const CollapseItem = ({ plain, title, titleIcon, className, ...rest }) => {
  const styles = classNames([`${plain ? 'plain-' : ''}collapse__item`, className]);

  return (
    <Panel
      {...rest}
      showArrow={false}
      header={<Title title={title} titleIcon={titleIcon} plain={plain} />}
      className={styles}
    />
  )
}

export { Collapse as default, CollapseItem }
